export default "/images/vendor/flag-icons/flags/4x3/za.svg?739f42e77d2a86f25792724a26dad56f";